import { render, staticRenderFns } from "./LinkIcon.vue?vue&type=template&id=23046a2b&scoped=true"
var script = {}
import style0 from "./LinkIcon.vue?vue&type=style&index=0&id=23046a2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23046a2b",
  null
  
)

export default component.exports